import React from 'react';
import { connect } from 'react-redux';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { BallInMotionIcon, SinglePersonV2Icon, MessageIcon, CollegeCornerIcon } from '@universal-tennis/ui-shared';
import { useTheme } from '@mui/material/styles';
import styles from './header.module.scss';

import Img from '../Img';
import BackgroundImage from '../BackgroundImage';
import { toggleSideMenu } from '../../redux/uiSlice';
import GlobalSearch from '../GlobalSearch';

import HomeIcon from '../../assets/icons/icon-home.svg';
import ProfileIcon from '../../assets/icons/icon-profile.svg';

import config from '../../config';
import { getClickAttrs } from '../../utils/analytics';
import { headerPropTypes } from '../../utils/proptypes';

const Header = (props) => {
    const theme = useTheme();
    const { auth } = props;
    const showHeaderItems = !!auth.user;

    const handleLogoClick = (e) => {
        e.preventDefault();

        if (auth?.user) {
            window.open(`${config.marketingAppHost}`, '_blank', 'noopener,noreferrer');
        } else {
            window.location.href = `${config.marketingAppHost}`;
        }
    };

    return (
        <div className="navbar-wrapper">
            <nav className={`navbar navbar-expand-md fixed-top navbar-light ${styles.nav}`}>
                <Container maxWidth="lg">
                    <Box display="flex" flexWrap="wrap" alignItems="center">
                        <button
                            type="button"
                            className="navbar-brand"
                            onClick={handleLogoClick}
                            {...getClickAttrs({
                                category: 'Header',
                                location: 'Header CTA',
                                context: `UTR icon`,
                            })}
                        >
                            <Img src="/img/utr_sports/utr-sports-logo.svg" />
                        </button>
                        <div className="nav-search-wrapper d-flex align-items-center">
                            <GlobalSearch auth={auth} />
                            <button type="button" className={`${styles.hamburger} d-block d-lg-none`} onClick={props.onMenuClick}>
                                <span className="sr-only">Toggle Menu</span>
                                <div className="d-flex flex-column align-items-center mr8">
                                    <span />
                                    <span />
                                    <span />
                                </div>
                            </button>
                        </div>
                        {!auth.user && (
                            <ul className={`${styles.nav} navbar-nav d-none d-lg-flex ml-auto`}>
                                <li className="nav-item">
                                    <a
                                        href={`${config.appHost}/login`}
                                        {...getClickAttrs({
                                            category: 'Sign In',
                                            location: 'Header CTA',
                                            context: 'Sign In button click',
                                        })}
                                    >
                                        SIGN IN
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a
                                        className={`btn btn-primary text-uppercase ${styles.joinBtn}`}
                                        href={`${config.appHost}/join`}
                                        {...getClickAttrs({
                                            category: 'Sign Up',
                                            location: 'Header CTA',
                                            context: 'Join button click',
                                        })}
                                    >
                                        JOIN
                                    </a>
                                </li>
                            </ul>
                        )}
                        {auth.user && (
                            <>
                                <div className={`${styles.nav} navbar-nav d-none d-lg-flex`}>
                                    <div className={`${styles.navLink} d-none d-lg-block ${auth.user ? styles.authed : ''}`}>
                                        <a
                                            className="underline"
                                            href={`${config.appHost}/home`}
                                            {...getClickAttrs({
                                                category: 'Header',
                                                location: 'Header CTA',
                                                context: 'Home',
                                            })}
                                        >
                                            Home
                                        </a>
                                    </div>
                                    <div className={`${styles.navLink} d-none d-lg-block ${auth.user ? styles.authed : ''}`}>
                                        <a
                                            className="underline clickable"
                                            href={`${config.appHost}/search?sportTypes=tennis,pickleball&type=players`}
                                            {...getClickAttrs({
                                                category: 'Header',
                                                location: 'Header CTA',
                                                context: 'Players',
                                            })}
                                        >
                                            Players
                                        </a>
                                    </div>
                                    <div className={`${styles.navLink} d-none d-lg-block ${auth.user ? styles.authed : ''}`}>
                                        <a
                                            className="underline clickable"
                                            href={`${config.appHost}/search?sportTypes=tennis,pickleball&type=events`}
                                            {...getClickAttrs({
                                                category: 'Header',
                                                location: 'Header CTA',
                                                context: 'Events',
                                            })}
                                        >
                                            Events
                                        </a>
                                    </div>
                                    <div className={`${styles.navLink} d-none d-lg-block ${auth.user ? styles.authed : ''}`}>
                                        <a
                                            className="underline clickable"
                                            href={`${config.appHost}/college-corner`}
                                            {...getClickAttrs({
                                                category: 'Header',
                                                location: 'Header CTA',
                                                context: 'College Corner',
                                            })}
                                        >
                                            College Corner
                                        </a>
                                    </div>
                                </div>
                                <div className={`${styles.nav} navbar-nav nav-bar-buttons d-none d-lg-flex ml-auto aic`}>
                                    <a
                                        className={styles.mobileNavLink}
                                        href="/inbox"
                                        {...getClickAttrs({
                                            category: 'Header',
                                            location: 'Header CTA',
                                            context: 'Messages',
                                        })}
                                    >
                                        <MessageIcon size={32} color={theme.appColors.black} />
                                    </a>
                                    <button
                                        className={`${styles.hamburger} d-none d-lg-block ${auth.user ? styles.authed : ''} ${styles.createPlay}`}
                                        type="button"
                                        onClick={() => props.toggleSideMenu()}
                                    >
                                        <span className="sr-only">Toggle Menu</span>
                                        <div className="d-flex flex-row align-items-center">
                                            <BackgroundImage
                                                baseUrl="/v1/player/"
                                                defaultImage={ProfileIcon}
                                                images={auth.user.claimedPlayer ? auth.user.claimedPlayer.playerProfileImages : null}
                                                imageType="thumbnail"
                                                parentStylesClass="avatar"
                                            />
                                        </div>
                                    </button>
                                </div>
                            </>
                        )}
                    </Box>
                </Container>
                {showHeaderItems && (
                    <div className="container d-block d-lg-none" style={{ position: 'relative' }}>
                        <div className="d-flex justify-space-around align-items-center h100">
                            <a
                                className={styles.mobileNavLink}
                                href={`${config.appHost}/home`}
                                {...getClickAttrs({
                                    category: 'Header',
                                    location: 'Header CTA',
                                    context: 'Home',
                                })}
                            >
                                <img src={HomeIcon} alt="home" />
                                <div className="title">Home</div>
                            </a>
                            <a
                                className={styles.mobileNavLink}
                                href={`${config.appHost}/search?sportTypes=tennis,pickleball&type=players`}
                                {...getClickAttrs({
                                    category: 'Header',
                                    location: 'Header CTA',
                                    context: 'Players',
                                })}
                            >
                                <SinglePersonV2Icon size={23} color={theme.appColors.black} />
                                <div className="title">Players</div>
                            </a>
                            <a
                                className={styles.mobileNavLink}
                                href={`${config.appHost}/search?sportTypes=tennis,pickleball&type=events`}
                                {...getClickAttrs({
                                    category: 'Header',
                                    location: 'Header CTA',
                                    context: 'Events',
                                })}
                            >
                                <BallInMotionIcon size={23} color={theme.appColors.black} />
                                <div className="title">Events</div>
                            </a>
                            <a
                                className={styles.mobileNavLink}
                                href={`${config.appHost}/college-corner`}
                                {...getClickAttrs({
                                    category: 'Header',
                                    location: 'Header CTA',
                                    context: 'College Corner',
                                })}
                            >
                                <CollegeCornerIcon size={23} color={theme.appColors.black} />
                                <div className="title">College Corner</div>
                            </a>
                            <button type="button" className={styles.mobileNavLink} onClick={() => props.toggleSideMenu()}>
                                <Img className="avatar" src="/img/v2/icons/icon-profile.svg" />
                                <div className="title">Menu</div>
                            </button>
                        </div>
                    </div>
                )}
            </nav>
        </div>
    );
};

const mapDispatchToProps = {
    toggleSideMenu,
};

function mapStateToProps({ auth }) {
    return { auth };
}

Header.propTypes = {
    ...headerPropTypes
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
